import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchClientData } from "../../features/influencerSlice/influencerSlice";
import { Button, Pagination, OverlayTrigger, Tooltip } from "react-bootstrap";
import AddNewClients from "./AddNewClients";
import UpdateInfluencer from "./UpdateInfluencer";
import DetailInfluencer from "./DetailInfluencer";
import AssigntoDm from "./AssigntoDm";
import UpdateStatus from "./UpdateStatus";
import { format } from "date-fns";
import Select from "react-select";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import useDecodedToken from "../../features/utils/hooks/useDecodedToken";
import { formatDate } from "../../utils/dateUtils";
import CryptoJS from "crypto-js";
import Breadcrumbs from "./../../Breadcrumbs";
import AssigntoDmTemp from "./AssigntoDmTemp";
import { getShowingRange } from "../../features/utils/paginationUtils";
import PaginationComponent from "../common/PaginationComponent";
import Filter from "../filter/Filter";
import { fetchDmTeam, InfluencerBulkAssign } from "../../features/commonSlice/commonSlice";
import { toast } from "react-toastify";

export const headerData = {
  sr_no: "SR No.",
  action: "Action",
  client_name: "Influencer Name",
  onboard_date: "Onboard Date",
  status: "Status",
  assign_by: "Assigned By",
  tmp_assign_to: "Temporary Assigned To",
  tmp_assign_date: "Temporary Assigned To Date",
  category: "Categories",
  email: "Email id",
  contact_per: "Contact Person",
  mobile: "Mobile Number",
  managed_by_dm: "Managed By DM",
  tmp_managed_by_dm: "Temporary Managed By DM",
  assigned_duration: "Temporary Assigned Duration",
  createdBy: "Created By",
};

const AssignedInfluencer = () => {
  const dispatch = useDispatch();
  const decodeToken = useDecodedToken();
  const navigate = useNavigate();
  const { assignedClientData, status } = useSelector((state) => state.clients);
  const [clientsData, setClientsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [clientsPerPage, setClientsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
  const [showModal, setShowModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showAssignSaleModal, setAssignSaleModel] = useState(false);
  const [showStatusModal, setStatusModel] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [apiMessage, setApiMessage] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [errorData, setErrorData] = useState([]);
  const [loginError, setLoginError] = useState("");

  const [showAssignTempModal, setAssignTempModel] = useState(false);
  const location = useLocation();
  const [formData, setFormData] = useState({
    channel_name: [],
    categories: [],
    languages: [],
    budget: { min: "", max: "" },
    subscribers: { min: "", max: "" },
    views: { min: "", max: "" },
    salesteam: null,
    inf_type: null,
    userName: null,
    follower_subscriber: null,
  });
  const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);
  const [filterType, setFilterType] = useState("assigned");
  const [filterCount, setFilterCount] = useState("");

  const [appliedFilters, setAppliedFilters] = useState(null);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [salesList, setSalesList] = useState([]);

  const { dmTeamData, status: commonStatus } = useSelector(
    (state) => state.influencer,
  );

  useEffect(() => {
    dispatch(fetchDmTeam());
  }, [dispatch]);

  useEffect(() => {
    setSalesList(dmTeamData?.data || []);
  }, [dmTeamData]);

  useEffect(() => {
    if (status === "succeeded") {
      const clientsData = assignedClientData?.data || [];
      setClientsData(assignedClientData?.data || []);

      if (assignedClientData?.status === false) {
        setApiMessage(assignedClientData?.message || "Something went wrong");
      } else {
        setApiMessage("");
      }
    }
  }, [status, assignedClientData]);

  // Sorting logic
  const sortTable = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  // Apply sorting
  const sortedData =
    sortConfig.key === ""
      ? clientsData
      : [...clientsData].sort((a, b) => {
        const aValue = a[sortConfig.key];
        const bValue = b[sortConfig.key];

        if (!aValue || !bValue) return 0;

        return sortConfig.direction === "ascending"
          ? aValue.toString().localeCompare(bValue.toString())
          : bValue.toString().localeCompare(aValue.toString());
      });

  // const clickAddNew = () => {
  //     setShowModal(true);
  // };
  // const handleUpdateClient = (rowData) => {
  //     setShowUpdateModal(true);
  //     setSelectedData(rowData);
  // };



  const handleSelectChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleBulkAssign = () => {
    if (!formData.salesteam) {
      alert("Please select DM");
      return;
    }

    if (!selectedRows.length) {
      alert("Please select at least one row");
      return;
    }
    try {
      const payload = {
        influencer_id: selectedRows,
        assigned_to: formData.salesteam, // ✅ FIXED
      };

      dispatch(InfluencerBulkAssign(payload))
        .unwrap()
        .then((result) => {
          if (result.status) {
            toast.success(result.message, {
              onClose: () => {
                setShowModal(false);
              },
            });
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          } else {
            setLoginError(result.message);
            setErrorData(result.form_err);
          }
        })
        .catch((err) => {
          setLoginError(err.message);
          setErrorData(err.form_err || []);
          toast.error(err.message);
        });
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };



  const handleDetailClient = (rowData) => {
    setSelectedData(rowData);
    const encryptedId = CryptoJS.AES.encrypt(
      rowData.id.toString(),
      "your_secret_key",
    ).toString();
    navigate(`/influencer-details/${rowData?.id}`, { state: rowData });
  };

  const handleAssigntodmtemp = (rowData) => {
    setAssignTempModel(true);
    setSelectedData(rowData);
  };

  const handleChangeStatus = (rowData) => {
    setStatusModel(true);
    setSelectedData(rowData);
  };
  const handleClientsPerPageChange = (selectedOption) => {
    setClientsPerPage(selectedOption.value);
    setCurrentPage(1); // Reset to first page whenever per page value changes
  };
  const perPageOptions = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: 2000, label: "All" }, // Add 'All' option
  ];

  const handleEditDetailClient = (rowData) => {
    setSelectedData(rowData);
    const encryptedId = CryptoJS.AES.encrypt(
      rowData.id.toString(),
      "your_secret_key",
    ).toString();
    navigate(`/influencer-update-details/${rowData?.id}`, { state: rowData });
  };

  // const paginationItems = getPaginationItems(currentPage, totalPages);
  const totalPages = assignedClientData?.pagination?.totalPages || 1;
  const totalItems = assignedClientData?.pagination?.totalItems || 0;
  const { start, end } = getShowingRange(
    currentPage,
    clientsPerPage,
    totalItems,
  );

  const openFilterDrawer = (type) => {
    setFilterType(type);
    setShowFiltersDrawer(true);
  };

  const updateFilterCount = () => {
    const saved = localStorage.getItem("influencer_filters");

    if (!saved) {
      setFilterCount(0);
      return;
    }

    try {
      const parsed = JSON.parse(saved);

      let count = 0;

      // ✅ Generic function to count only valid selected filters
      const countFilter = (filter) => {
        if (!filter) return 0;

        // Multi Select
        if (Array.isArray(filter)) {
          return filter.filter(
            (item) =>
              item &&
              item.value !== null &&
              item.value !== "" &&
              item.value !== undefined,
          ).length;
        }

        // Single Select
        return filter.value !== null &&
          filter.value !== "" &&
          filter.value !== undefined
          ? 1
          : 0;
      };

      // ✅ Count all filters
      count += countFilter(parsed?.inf_type);
      count += countFilter(parsed?.user_id);
      count += countFilter(parsed?.follower_subscriber);

      setFilterCount(count);
    } catch (err) {
      console.error(err);
      setFilterCount(0);
    }
  };

  const handleAssigntosaleClient = (rowData) => {
    setAssignSaleModel(true);
    setSelectedData(rowData);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = (sortedData || []).map((item) => item.id);
      setSelectedRows(allIds);
    } else {
      setSelectedRows([]);
    }
  };
  const handleRowSelect = (id) => {
    setSelectedRows((prev = []) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id],
    );
  };

  useEffect(() => {
    const saved = localStorage.getItem("influencer_filters");

    if (saved) {
      try {
        const parsed = JSON.parse(saved);

        // ✅ Restore UI values
        setFormData((prev) => ({
          ...prev,
          inf_type: parsed?.inf_type || null,
          userName: parsed?.user_id || null,
          follower_subscriber: parsed?.follower_subscriber || null,
        }));

        // ✅ API payload
        const payload = {
          status_id: parsed?.filterType === "active" ? "1" : "99",
          page: 1,
          limit: clientsPerPage === 2000 ? "All" : clientsPerPage,

          inf_type: Array.isArray(parsed?.inf_type)
            ? parsed.inf_type.map((i) => i.value)
            : parsed?.inf_type?.value || null,

          user_id: Array.isArray(parsed?.user_id)
            ? parsed.user_id.map((i) => i.value)
            : parsed?.user_id?.value || null,

          follower_subscriber: Array.isArray(parsed?.follower_subscriber)
            ? parsed.follower_subscriber.map((i) => i.value)
            : parsed?.follower_subscriber?.value || null,
        };

        setAppliedFilters(payload);
        setIsFilterApplied(true);

        // ✅ Update count
        updateFilterCount();
      } catch (err) {
        console.error("Invalid localStorage data");
      }
    }
  }, []);

  useEffect(() => {
    const payload =
      isFilterApplied && appliedFilters
        ? {
          ...appliedFilters,
          page: currentPage,
          limit: clientsPerPage === 2000 ? "All" : clientsPerPage,
        }
        : {
          status_id: "5",
          page: currentPage,
          limit: clientsPerPage === 2000 ? "All" : clientsPerPage,
          inf_type: null,
          user_id: null,
          follower_subscriber: null,
        };

    dispatch(fetchClientData(payload));
  }, [dispatch, currentPage, clientsPerPage, isFilterApplied, appliedFilters]);

  const handleFilter = () => {
    let infTypeValue = null;

    if (Array.isArray(formData?.inf_type)) {
      infTypeValue = formData.inf_type.map((i) => Number(i.value));
    } else if (formData?.inf_type?.value) {
      infTypeValue = Number(formData.inf_type.value);
    }

    // ✅ user_id value
    let userIdValue = null;

    if (formData?.userName?.value) {
      userIdValue = Number(formData.userName.value);
    }
    const followSubscriberId = formData?.follower_subscriber?.value || "";
    const payload = {
      status_id: "5",
      page: 1,
      limit: clientsPerPage === 2000 ? "All" : clientsPerPage,
      inf_type: infTypeValue || null,
      user_id: userIdValue || null,
      follower_subscriber: followSubscriberId || null,
    };

    const filterUIData = {
      inf_type: formData?.inf_type || null,
      user_id: formData?.userName || null,
      follower_subscriber: formData?.follower_subscriber,
      filterType, // optional (good for restoring tab)
    };

    setAppliedFilters(payload);
    setIsFilterApplied(true);
    setCurrentPage(1);

    setShowFiltersDrawer(false);

    localStorage.setItem("influencer_filters", JSON.stringify(filterUIData));

    updateFilterCount();
  };

  const handleReset = () => {
    setFormData({
      inf_type: null,
      userName: null,
      follower_subscriber: null,
    });

    setAppliedFilters(null);
    setIsFilterApplied(false);
    setCurrentPage(1);

    localStorage.removeItem("influencer_filters");
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">Assigned Influencer</h4>

            <div className="page-title-right">
              <Breadcrumbs />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="card" id="leadsList">
            <div className="card-header border-0">
              <div className="row g-4 align-items-center">
                <div className="col-sm-1">
                  <label className="small">Select Records</label>
                  <Select
                    className="basic-single small"
                    classNamePrefix="select"
                    name="perPage"
                    options={perPageOptions}
                    defaultValue={perPageOptions[0]}
                    onChange={handleClientsPerPageChange}
                  />
                </div>
                <div className="col-sm-auto ms-auto">
                  <div className="hstack gap-2">
                    {(decodeToken?.UsrRoleId === 1 ||
                      decodeToken?.UsrRoleId === 3 ||
                      decodeToken?.UsrRoleId === 10 ||
                      decodeToken?.UsrRoleId === 11) && (
                        <>
                          <Select
                            name="salesteam"
                            options={salesList || []}
                            classNamePrefix="select"
                            onChange={(selected) =>
                              handleSelectChange("salesteam", selected)
                            }
                            value={formData.salesteam || null}
                          />
                          <Button
                            className="btn btn-success add-btn"
                            onClick={() => handleBulkAssign()}
                            disabled={
                              selectedRows.length === 0 || !formData?.salesteam
                            }
                          >
                            <i className="ri-user-shared-fill align-bottom me-1"></i>
                            Assign
                          </Button>
                        </>
                      )}

                    {/* <button
                      type="button"
                      className="btn btn-info"
                      onClick={() => openFilterDrawer("assigned")}
                    >
                      <i className="ri-filter-3-line align-bottom me-1"></i>{" "}
                      Filters
                      {filterCount > 0 && (
                        <span
                          className="position-absolute top-0 start-98 translate-middle badge rounded-pill bg-danger"
                          style={{
                            fontSize: "10px",
                            marginTop: "8px",
                            marginLeft: "7px",
                          }}
                        >
                          {filterCount}
                        </span>
                      )}
                    </button> */}
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="inactive-filter-tooltip">
                          Add Filter
                        </Tooltip>
                      }
                    >
                      <button
                        type="button"
                        className="btn btn-info "
                        onClick={() => openFilterDrawer("assigned")}
                      >
                        <i className="ri-filter-line align-bottom me-1"></i>{" "}
                        {filterCount > 0 && (
                          <span
                            className="position-absolute top-0 start-98 translate-middle badge rounded-pill bg-danger"
                            style={{
                              fontSize: "10px",
                              marginTop: "8px",
                              marginLeft: "7px",
                            }}
                          >
                            {filterCount}
                          </span>
                        )}
                      </button>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="pending-clear-filter-tooltip">
                          Clear Filter
                        </Tooltip>
                      }
                    >
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={handleReset}
                      >
                        <i className="ri-filter-off-line align-bottom me-1"></i>{" "}
                      </button>
                    </OverlayTrigger>
                    {/* <Button className="btn btn-sm btn-success add-btn" onClick={clickAddNew}>
                                            <i className="ri-add-line align-bottom me-1"></i> Add Influencer
                                        </Button> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table
                  id="example"
                  className="table table-bordered nowrap table-striped align-middle"
                  style={{ width: "100%" }}
                >
                  <thead>
                    <tr>
                      {(decodeToken?.UsrRoleId === 1 ||
                        decodeToken?.UsrRoleId === 3 ||
                        decodeToken?.UsrRoleId === 10 ||
                        decodeToken?.UsrRoleId === 11 ||
                        decodeToken?.UsrRoleId === 16) && (
                          <th>
                            <input
                              type="checkbox"
                              onChange={handleSelectAll}
                              checked={
                                selectedRows.length === sortedData.length &&
                                sortedData.length > 0
                              }
                            />
                          </th>
                        )}
                      <th>{headerData.sr_no}</th>
                      <th>{headerData.action}</th>
                      <th onClick={() => sortTable("name")}>
                        {headerData.client_name}
                      </th>
                      <th>{headerData.onboard_date}</th>
                      <th>{headerData.status}</th>
                      <th>{headerData.email}</th>
                      <th>{headerData.contact_per}</th>
                      <th>{headerData.mobile}</th>
                      <th>{headerData.assign_by}</th>
                      <th>{headerData.managed_by_dm}</th>
                      <th>{headerData.tmp_managed_by_dm}</th>
                      <th>{headerData.assigned_duration}</th>
                      <th>{headerData.createdBy}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {apiMessage ? (
                      <tr>
                        <td colSpan="12" className="text-center text-danger">
                          {apiMessage}
                        </td>
                      </tr>
                    ) : sortedData.length > 0 ? (
                      sortedData.map((dataActive, index) => (
                        <tr key={index}>
                          {(decodeToken?.UsrRoleId === 1 ||
                            decodeToken?.UsrRoleId === 3 ||
                            decodeToken?.UsrRoleId === 10 ||
                            decodeToken?.UsrRoleId === 11 ||
                            decodeToken?.UsrRoleId === 16) && (
                              <td>
                                <input
                                  type="checkbox"
                                  checked={
                                    selectedRows?.includes(dataActive.id) ||
                                    false
                                  }
                                  onChange={() =>
                                    handleRowSelect(dataActive.id)
                                  }
                                />
                              </td>
                            )}
                          <td>
                            {(currentPage - 1) * clientsPerPage + index + 1}
                          </td>
                          <td>
                            <ul className="list-inline hstack mb-0">
                              <li
                                className="list-inline-item"
                                data-bs-toggle="tooltip"
                                data-bs-trigger="hover"
                                data-bs-placement="top"
                                aria-label="View"
                                data-bs-original-title="View"
                              >
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id="tooltip-top">
                                      {dataActive.assigned_to_id ===
                                        decodeToken?.UsrId ||
                                        dataActive.tmp_assigned_to_id ===
                                        decodeToken?.UsrId ||
                                        decodeToken?.UsrRoleId === 1 ||
                                        decodeToken?.UsrRoleId === 10
                                        ? "Edit Detail"
                                        : "View Restricted"}
                                    </Tooltip>
                                  }
                                >
                                  <Button
                                    className="btn btn-sm btn-default edit-item-btn"
                                    onClick={
                                      dataActive.assigned_to_id ===
                                        decodeToken?.UsrId ||
                                        dataActive.tmp_assigned_to_id ===
                                        decodeToken?.UsrId ||
                                        decodeToken?.UsrRoleId === 1 ||
                                        decodeToken?.UsrRoleId === 10
                                        ? () =>
                                          handleEditDetailClient(dataActive)
                                        : (e) => e.preventDefault()
                                    }
                                    disabled={
                                      !(
                                        dataActive.assigned_to_id ===
                                        decodeToken?.UsrId ||
                                        dataActive.tmp_assigned_to_id ===
                                        decodeToken?.UsrId ||
                                        decodeToken?.UsrRoleId === 1 ||
                                        decodeToken?.UsrRoleId === 10
                                      )
                                    }
                                  >
                                    <i className="ri-edit-fill align-bottom"></i>
                                  </Button>
                                </OverlayTrigger>
                              </li>
                              <li
                                className="list-inline-item"
                                data-bs-toggle="tooltip"
                                data-bs-trigger="hover"
                                data-bs-placement="top"
                                aria-label="View"
                                data-bs-original-title="View"
                              >
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id="tooltip-top">
                                      {dataActive.assigned_to_id ===
                                        decodeToken?.UsrId ||
                                        dataActive.tmp_assigned_to_id ===
                                        decodeToken?.UsrId ||
                                        decodeToken?.UsrRoleId === 1 ||
                                        decodeToken?.UsrRoleId === 10
                                        ? "View Detail"
                                        : "View Restricted"}
                                    </Tooltip>
                                  }
                                >
                                  <Button
                                    className="btn btn-sm btn-info edit-item-btn"
                                    onClick={
                                      dataActive.assigned_to_id ===
                                        decodeToken?.UsrId ||
                                        dataActive.tmp_assigned_to_id ===
                                        decodeToken?.UsrId ||
                                        decodeToken?.UsrRoleId === 1 ||
                                        decodeToken?.UsrRoleId === 10
                                        ? () => handleDetailClient(dataActive)
                                        : (e) => e.preventDefault()
                                    }
                                    disabled={
                                      !(
                                        dataActive.assigned_to_id ===
                                        decodeToken?.UsrId ||
                                        dataActive.tmp_assigned_to_id ===
                                        decodeToken?.UsrId ||
                                        decodeToken?.UsrRoleId === 1 ||
                                        decodeToken?.UsrRoleId === 10
                                      )
                                    }
                                  >
                                    <i className="ri-eye-fill align-bottom"></i>
                                  </Button>
                                </OverlayTrigger>
                              </li>
                              {/* {decodeToken?.UsrRoleId === 3 && ( */}
                              {(decodeToken?.UsrRoleId === 1 ||
                                decodeToken?.UsrRoleId === 3 ||
                                decodeToken?.UsrRoleId === 10 ||
                                decodeToken?.UsrRoleId === 11 ||
                                decodeToken?.UsrRoleId === 16) && (
                                  <li
                                    className="list-inline-item"
                                    data-bs-toggle="tooltip"
                                    data-bs-trigger="hover"
                                    data-bs-placement="top"
                                    aria-label="View"
                                    data-bs-original-title="View"
                                  >
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip id="tooltip-top">
                                          {dataActive.status === 1
                                            ? "Assign to DM team"
                                            : dataActive.status === 5
                                              ? "Temprary assign to DM team"
                                              : "Assign Restricted"}
                                        </Tooltip>
                                      }
                                    >
                                      <Button
                                        className={`btn btn-sm btn-warning edit-item-btn ${dataActive.status === 1 ||
                                          dataActive.status === 5
                                          ? ""
                                          : "disabled-btn"
                                          }`}
                                        onClick={
                                          dataActive.status === 1
                                            ? () =>
                                              handleAssigntosaleClient(
                                                dataActive,
                                              )
                                            : dataActive.status === 5
                                              ? () =>
                                                handleAssigntodmtemp(dataActive)
                                              : (e) => e.preventDefault()
                                        }
                                        style={{
                                          cursor:
                                            dataActive.status === 1 ||
                                              dataActive.status === 5
                                              ? "pointer"
                                              : "not-allowed",
                                        }}
                                      >
                                        <i
                                          className={`ri-${dataActive.status !== 5
                                            ? "share"
                                            : "send-plane"
                                            }-fill align-bottom me-1 ${dataActive.status === 4 ||
                                              dataActive.status === 5
                                              ? ""
                                              : "restricted-icon"
                                            }`}
                                        ></i>
                                      </Button>
                                    </OverlayTrigger>
                                  </li>
                                )}
                              {/* <li
                                className="list-inline-item"
                                data-bs-toggle="tooltip"
                                data-bs-trigger="hover"
                                data-bs-placement="top"
                              >
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id="tooltip-top">
                                      {decodeToken?.UsrRoleId === 3 ||
                                      decodeToken?.UsrRoleId === 5
                                        ? "Access Restricted"
                                        : dataActive.status === 1
                                          ? "Assign to DM team"
                                          : dataActive.status === 5
                                            ? "Temporary assign to DM team"
                                            : "Assign Restricted"}
                                      </Tooltip>
                                    }
                                  >
                                    <Button
                                      className={`btn btn-sm btn-warning edit-item-btn ${
                                        !(
                                          dataActive.status === 1 ||
                                          dataActive.status === 5
                                        )
                                          ? "disabled-btn"
                                          : ""
                                      }`}
                                      disabled={
                                        !(
                                          dataActive.status === 1 ||
                                          dataActive.status === 5
                                        )
                                      }
                                      onClick={
                                        dataActive.status === 1
                                          ? () =>
                                              handleAssigntosaleClient(
                                                dataActive,
                                              )
                                          : dataActive.status === 5
                                            ? () =>
                                                handleAssigntodmtemp(dataActive)
                                            : (e) => e.preventDefault()
                                      }
                                      style={{
                                        cursor: !(
                                          dataActive.status === 1 ||
                                          dataActive.status === 5
                                        )
                                          ? "not-allowed"
                                          : "pointer",
                                    }}
                                  >
                                    <i
                                      className={`ri-${
                                        dataActive.status !== 5
                                          ? "share"
                                          : "send-plane"
                                      }-fill align-bottom me-1 ${
                                        dataActive.status === 4 ||
                                        dataActive.status === 5
                                          ? ""
                                          : "restricted-icon"
                                      }`}
                                    ></i>
                                  </Button>
                                </OverlayTrigger>
                              </li> */}
                            </ul>
                          </td>
                          <td>{dataActive.name}</td>
                          <td> {formatDate(dataActive.created_at)} </td>
                          <td>
                            <span
                              className={`badge w-100 ${dataActive.user_status === "Active"
                                ? "bg-success-subtle text-success"
                                : dataActive.user_status === "Assigned"
                                  ? "bg-info-subtle text-info"
                                  : dataActive.user_status === "Inactive"
                                    ? "bg-danger-subtle text-danger"
                                    : dataActive.user_status === "Pending" &&
                                    "bg-warning-subtle text-warning"
                                }`}
                            >
                              {decodeToken?.UsrRoleId === 1 ||
                                decodeToken?.UsrRoleId === 10 ? (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id="tooltip-top">
                                      {dataActive.user_status}
                                    </Tooltip>
                                  }
                                >
                                  <button
                                    style={{ cursor: "pointer" }}
                                    onClick={
                                      decodeToken?.UsrRoleId === 1 ||
                                        decodeToken?.UsrRoleId === 10
                                        ? () => handleChangeStatus(dataActive)
                                        : null
                                    }
                                    className="btn btn-default btn-sm m-0 p-0"
                                  >
                                    {dataActive.user_status}{" "}
                                  </button>
                                </OverlayTrigger>
                              ) : (
                                <span className="px-1">
                                  {dataActive.user_status}
                                </span>
                              )}
                            </span>
                          </td>

                          <td>{dataActive.email}</td>
                          <td>{dataActive.concern_person_name}</td>
                          <td>{dataActive.mobile_no}</td>
                          <td>{dataActive.assigned_by_name}</td>
                          <td>
                            {dataActive.assigned_to_id ===
                              decodeToken?.UsrId ? (
                              <span className="text-success p-2">You</span>
                            ) : (
                              dataActive.assigned_to_name
                            )}
                          </td>

                          <td>
                            {dataActive.tmp_assigned_to_id ===
                              decodeToken?.UsrId ? (
                              <span className="text-success p-2">You</span>
                            ) : dataActive.tmp_assigned_to_name ? (
                              dataActive.tmp_assigned_to_name
                            ) : (
                              "-"
                            )}
                          </td>
                          <td>
                            {`${dataActive.to_date != "" &&
                              dataActive.to_date != null
                              ? formatDate(dataActive.created_at)
                              : "-"
                              }`}
                          </td>
                          <td>{dataActive.created_by_name}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="12" className="text-center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="row">
                {clientsPerPage !== 2000 && (
                  <>
                    <div className="col-sm-6">
                      Showing {start} to {end} of {totalItems} entries
                    </div>

                    <div className="col-sm-6">
                      <PaginationComponent
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={(page) => setCurrentPage(page)}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddNewClients showModal={showModal} setShowModal={setShowModal} />
      <UpdateInfluencer
        showModal={showUpdateModal}
        setShowModal={setShowUpdateModal}
        selectedData={selectedData}
      />
      <Filter
        setShowFiltersDrawer={setShowFiltersDrawer}
        showFiltersDrawer={showFiltersDrawer}
        handleFilter={handleFilter}
        formData={formData}
        setFormData={setFormData}
        filterType={filterType}
        handleReset={handleReset}
      />
      <AssigntoDm
        showModal={showAssignSaleModal}
        setShowModal={setAssignSaleModel}
        selectedData={selectedData}
      />
      <AssigntoDmTemp
        showModal={showAssignTempModal}
        setShowModal={setAssignTempModel}
        selectedData={selectedData}
      />
      <UpdateStatus
        showModal={showStatusModal}
        setShowModal={setStatusModel}
        selectedData={selectedData}
      />
    </>
  );
};

export default AssignedInfluencer;
